import { defineComponent as _defineComponent } from 'vue'
import { inject } from 'vue'
import { GeoImagesViewModelKey } from '../keys/GeoImagesViewModel.key'
import { BandTypeEnum } from '../../../../@core/lidar/domain/enums/BandType.enum'
import Breadcrumb from '../../../../components/ui/breadcrumb/Breadcrumb.vue'
import MapBandRow from './MapBandRow.vue'
import Button from '../../../../components/Button/Button.vue'
import Message from '../../../../components/ui/message/Message.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MapBandsForm',
  setup(__props) {

const vm = inject(GeoImagesViewModelKey)!

function updateBandMapping(bandType: BandTypeEnum, value: string) {
	vm.bandMapping.value[bandType] = value
}

return { __sfc: true,vm, updateBandMapping, BandTypeEnum, Breadcrumb, MapBandRow, Button, Message }
}

})